import Tracker from "@openreplay/tracker";

let openReplayTracker: Tracker | null = null;
let openReplayStarted = false;

const openReplayEnabled = (): boolean =>
  import.meta.env.VITE_OPENREPLAY_ENABLED !== "false" &&
  Boolean(import.meta.env.VITE_OPENREPLAY_PROJECT_KEY);

export const initOpenReplay = (): Tracker | null => {
  if (!openReplayEnabled()) return null;
  if (typeof window === "undefined") return null;

  if (!openReplayTracker) {
    openReplayTracker = new Tracker({
      projectKey: import.meta.env.VITE_OPENREPLAY_PROJECT_KEY as string,
      ...(import.meta.env.VITE_OPENREPLAY_INGEST_POINT
        ? { ingestPoint: import.meta.env.VITE_OPENREPLAY_INGEST_POINT }
        : {}),
      //__DISABLE_SECURE_MODE:true to enable on localhost
    });
  }

  if (!openReplayStarted) {
    openReplayTracker.start();
    openReplayStarted = true;
  }

  return openReplayTracker;
};

export const setOpenReplayUserId = (userId: string): void => {
  const tracker = initOpenReplay();
  if (!tracker) return;
  tracker.setUserID(userId);
};
